import Vue from 'vue'
import App from './App'
import router from './router'
import axiosApi from 'axios';
import urlHost from './config';
import VuePaginate from 'vue-paginate';

Vue.use(VuePaginate);

/* if (process.env.NODE_ENV == "development") {
  // var url = 'http://localhost/'
  var url = 'http://dev.denarius/'
} else {
  var url = urlHost
}; */

var url = urlHost

var _ = require('lodash');

const axios = axiosApi.create({
    baseURL: url,
    timeout: 30000
});

//Use the window object to make it available globally.
window.axios = axios;

Vue.config.productionTip = false

Vue.prototype.$baseUrl = url;

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js